import { IAccountsDomain, Pangolin } from 'services/accounts/types';
import * as PangolinService from 'services/accounts/pangolin_service';
import { StringStore } from 'ui/base/input';
import { ShieldIconSelectorStore } from 'ui/standard/image/shield_icon_selector/shield_icon_selector.store';
import { TimezoneStore } from 'ui/standard/input/timezone_input/timezone_store';
import { ResultKind } from 'services/base/types';
import { action, observable, runInAction } from 'mobx';
import { BusyStore } from 'ui/base/button';

export class EditPangolinStore {
  readonly pangolin: Pangolin;
  readonly nickname: StringStore;
  readonly timezone: TimezoneStore;
  shieldIcon: ShieldIconSelectorStore;

  @observable.ref
  nicknameError: string | undefined;

  @observable.ref
  shieldIconError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor(pangolin: Pangolin) {
    this.pangolin = pangolin;
    this.nickname = new StringStore(pangolin.nickname);
    this.timezone = new TimezoneStore(pangolin.timezone);
    this.shieldIcon = new ShieldIconSelectorStore(pangolin.colorCode);
    this.busy = new BusyStore();
  }

  @action.bound
  async handleSave(accounts: IAccountsDomain) {
    if (accounts.pangolins.has(this.pangolin.id)) {
      const result = await PangolinService.update({
        domain: accounts,
        id: this.pangolin.id,
        nickname: this.nickname.value,
        colorCode: this.shieldIcon.value,
        timezone: this.timezone.name.value,
      });

      return runInAction(() => {
        if (result.kind === ResultKind.USER_ERROR) {
          this.nicknameError = result.nicknameError;
          this.shieldIconError = result.colorCodeError;
        }
        return result;
      });
    }

    return { kind: ResultKind.SYSTEM_ERROR };
  }
}
